// Asset Management — shared demo data (sample data, not production)

export const ASSETS = [
  {
    id: 'AST-001',
    name: 'Solano Wind Farm',
    stage: 'Operational',
    sector: 'Renewable Energy',
    subSector: 'Onshore Wind',
    country: 'United Kingdom',
    fund: 'SeedDrive Infrastructure Fund I',
    fundExposure: 42.5,
    debtStack: true,
    shareholdingPct: 60,
    description: 'A 120 MW onshore wind farm located in the Scottish Highlands, commissioned in 2019. Long-term CfD contract in place through 2039.',
    acquisitionDate: '2019-03-15',
    keyExpiryDates: [{ label: 'CfD Contract', date: '2039-03-14' }, { label: 'Land Lease', date: '2044-06-30' }],
    keyOperationalDates: [{ label: 'Full Commissioning', date: '2019-06-01' }, { label: 'Last Major Service', date: '2024-11-10' }],
    totalInvestmentValue: 85.2,
    lastReviewDate: '2025-09-30',
    reviewStatus: 'Reviewed',
    watchlistStatus: 'Confirmed with actions',
    riskScore: 3,
    counterpartyRiskScore: 2,
    disputesStatus: 'None',
    stakeholderStatus: 'Strong',
    situationUpdate: 'Q1 2026: availability strong at 97.2%, wind resource above P50. Capex programme 3 weeks behind schedule due to contractor resourcing constraints. Revised programme under review.',
    irr: 12.4,
    yield1to10: 6.8,
    yield11to20: 7.2,
    yield21to25: 5.9,
    yieldLifetime: 6.9,
    multiple: 2.1,
    cashYieldActual: 6.5,
    cashYieldBudget: 6.3,
    irrHistory: [
      { period: 'Q1 2022', irr: 10.2 }, { period: 'Q2 2022', irr: 10.8 }, { period: 'Q3 2022', irr: 11.1 },
      { period: 'Q4 2022', irr: 11.5 }, { period: 'Q1 2023', irr: 11.8 }, { period: 'Q2 2023', irr: 12.0 },
      { period: 'Q3 2023', irr: 12.1 }, { period: 'Q4 2023', irr: 12.2 }, { period: 'Q1 2024', irr: 12.3 },
      { period: 'Q2 2024', irr: 12.4 }, { period: 'Q3 2024', irr: 12.4 }, { period: 'Q4 2024', irr: 12.4 },
    ],
    outperformanceDrivers: 'Wind resource above P50 in Q1 2026. Availability at 97.2%, above contracted minimum. No HSE incidents. IRR tracking in line with acquisition case.',
    underperformanceDrivers: 'Capex programme running 3 weeks behind schedule due to contractor resourcing constraints. Revised programme under review. Projected overrun within contingency.',
    assetTimeline: 'Acquired March 2019. Full commissioning June 2019. O&M contract renegotiated 2022. Major service completed November 2024. Q1 2026 capex programme ongoing.',
    reviewSummary: 'Q1 2026 review: confirmed with actions. Availability and IRR on track. Capex delay flag — contractor programme review required by 30 April.',
    agreedActions: null,
    agreedActionsList: [
      { action: 'Contractor programme review and revised schedule', owner: 'Tom Hargreaves', dueDate: '2026-04-30', status: 'in-progress' },
    ],
    nextReviewDate: '2026-09-30',
    valuationStatus: 'Submitted',
    valuationNotes: 'Valuation submitted to committee October 2025. Uplift of 4.2% on prior year.',
    operationalFacts: 'P50 wind resource exceeded Q1 2026. Availability 97.2%. Capex programme 3 weeks behind schedule. No HSE incidents.',
    valuationAssumptions: 'Discount rate held at 7.5%. Inflation assumption 2.5%. CfD indexation confirmed.',
    riskTrend: [2, 2, 3],
    reviewChain: [
      { role: 'Asset Manager',      name: 'Priya Sharma',    initials: 'PS', signed: true,  signedDate: '2026-04-08' },
      { role: 'Head of Renewables', name: 'Tom Hargreaves',  initials: 'TH', signed: true,  signedDate: '2026-04-09' },
      { role: 'Portfolio Director', name: 'James Harrison',  initials: 'JH', signed: false, signedDate: null },
    ],
    monitoringCadence: 'annual',
    counterparties: [
      { type: 'Client', name: 'National Grid ESO', contact: 'grid.contracts@nationalgrid.com', phone: '+44 1926 653000', lastContacted: '2025-10-15', notes: 'CfD settlement queries resolved.' },
      { type: 'PPA Provider', name: 'Octopus Energy', contact: 'commercial@octopus.energy', phone: '+44 808 164 1088', lastContacted: '2025-09-01', notes: 'PPA renewal discussions ongoing.' },
      { type: 'Insurer', name: 'Allianz Global Corporate', contact: 'infra@allianz.com', phone: '+44 20 3451 3000', lastContacted: '2025-08-20', notes: 'Annual renewal completed.' },
      { type: 'Co-Shareholder', name: 'Greencoat Capital', contact: 'ir@greencoat.com', phone: '+44 20 7832 9400', lastContacted: '2025-11-01', notes: 'Board meeting minutes shared.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Sarah Mitchell', email: 's.mitchell@seedrive.com', phone: '+44 7700 900001', lastContacted: '2025-12-01', notes: '' },
      { role: 'Sector Lead', name: 'David Okafor', email: 'd.okafor@seedrive.com', phone: '+44 7700 900002', lastContacted: '2025-11-28', notes: '' },
      { role: 'Finance Contact', name: 'Priya Sharma', email: 'p.sharma@seedrive.com', phone: '+44 7700 900003', lastContacted: '2025-12-01', notes: '' },
    ],
    valuationCreationActions: [
      { id: 'VC-001-A', action: 'Renegotiate O&M contract', status: 'Delivered', notes: 'Completed 2022. Savings of £0.4m p.a.', owner: 'S. Mitchell', targetDate: '2022-12-31', valueImpact: 4.2 },
      { id: 'VC-001-B', action: 'Explore battery co-location', status: 'In progress', notes: 'Feasibility study underway.', owner: 'D. Okafor', targetDate: '2026-06-30', valueImpact: 8.5 },
    ],
    valuationPostActions: [
      { id: 'VC-001-C', action: 'Grid connection upgrade', status: 'Planned', notes: 'Awaiting DNO confirmation.', owner: 'S. Mitchell', targetDate: '2027-03-31', valueImpact: 3.1 },
    ],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Complete', hsePolicy: 'Current', esgPolicy: 'Current', annualValuationNotes: 'Submitted October 2025. Approved by committee.', consistencyCheck: true, consistencyCommentary: 'Review information aligns with risk register. No discrepancies noted.' },
    irrTarget: 11.5,
    esgScore: 76,
    dpi: 0.62,
    exitProjectedYear: 2034,
    spvId: 'spv-solano',
  },
  {
    id: 'AST-002',
    name: 'Meridian Solar Park',
    stage: 'Operational',
    sector: 'Renewable Energy',
    subSector: 'Solar PV',
    country: 'Spain',
    fund: 'SeedDrive Infrastructure Fund I',
    fundExposure: 31.0,
    debtStack: true,
    shareholdingPct: 49,
    description: 'A 75 MW ground-mounted solar PV facility in Extremadura, Spain. Merchant revenue with partial PPA coverage.',
    acquisitionDate: '2020-07-22',
    keyExpiryDates: [{ label: 'PPA Contract', date: '2030-07-21' }, { label: 'Grid Connection', date: '2045-12-31' }],
    keyOperationalDates: [{ label: 'COD', date: '2020-10-01' }, { label: 'PPA Start', date: '2020-10-01' }],
    totalInvestmentValue: 62.0,
    lastReviewDate: '2025-06-30',
    reviewStatus: 'Reviewed',
    watchlistStatus: 'Confirmed with actions',
    riskScore: 3,
    counterpartyRiskScore: 3,
    disputesStatus: 'Minor',
    stakeholderStatus: 'Satisfactory',
    situationUpdate: 'Merchant price exposure creating revenue volatility. PPA renewal negotiations commenced.',
    irr: 9.8,
    yield1to10: 5.2,
    yield11to20: 6.1,
    yield21to25: 5.5,
    yieldLifetime: 5.7,
    multiple: 1.8,
    cashYieldActual: 4.9,
    cashYieldBudget: 5.5,
    irrHistory: [
      { period: 'Q1 2022', irr: 10.5 }, { period: 'Q2 2022', irr: 10.2 }, { period: 'Q3 2022', irr: 9.8 },
      { period: 'Q4 2022', irr: 9.5 }, { period: 'Q1 2023', irr: 9.6 }, { period: 'Q2 2023', irr: 9.7 },
      { period: 'Q3 2023', irr: 9.9 }, { period: 'Q4 2023', irr: 9.8 }, { period: 'Q1 2024', irr: 9.7 },
      { period: 'Q2 2024', irr: 9.8 }, { period: 'Q3 2024', irr: 9.8 }, { period: 'Q4 2024', irr: 9.8 },
    ],
    outperformanceDrivers: 'Higher irradiation in 2023. Operational efficiency improvements.',
    underperformanceDrivers: 'Merchant price decline in H2 2024. Minor grid curtailment.',
    assetTimeline: 'Acquired July 2020. COD October 2020. PPA renegotiation commenced 2025.',
    reviewSummary: 'Confirmed with actions. PPA renewal to be prioritised. Revenue hedging strategy to be reviewed.',
    agreedActions: 'Complete PPA renewal by Q2 2026. Engage revenue hedging adviser by Q1 2026.',
    nextReviewDate: '2026-06-30',
    valuationStatus: 'Under review',
    valuationNotes: 'Valuation under review pending PPA outcome.',
    operationalFacts: 'Availability 96.8%. P50 generation broadly achieved.',
    valuationAssumptions: 'Merchant price assumption under review. PPA renewal terms to be incorporated.',
    riskTrend: [2, 3, 3],
    monitoringCadence: 'quarterly',
    counterparties: [
      { type: 'PPA Provider', name: 'Iberdrola', contact: 'ppa@iberdrola.es', phone: '+34 944 151 411', lastContacted: '2025-11-10', notes: 'Renewal negotiations ongoing.' },
      { type: 'Regulator', name: 'CNMC Spain', contact: 'info@cnmc.es', phone: '+34 91 432 9600', lastContacted: '2025-07-01', notes: 'Regulatory filing submitted.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Carlos Reyes', email: 'c.reyes@seedrive.com', phone: '+44 7700 900010', lastContacted: '2025-12-01', notes: '' },
      { role: 'Finance Contact', name: 'Priya Sharma', email: 'p.sharma@seedrive.com', phone: '+44 7700 900003', lastContacted: '2025-11-20', notes: '' },
    ],
    valuationCreationActions: [
      { id: 'VC-002-A', action: 'Secure long-term PPA extension', status: 'In progress', notes: 'Negotiations with Iberdrola ongoing.', owner: 'C. Reyes', targetDate: '2026-06-30', valueImpact: 12.0 },
    ],
    valuationPostActions: [
      { id: 'VC-002-B', action: 'Revenue hedging strategy', status: 'Planned', notes: 'Adviser to be appointed Q1 2026.', owner: 'C. Reyes', targetDate: '2026-03-31', valueImpact: 5.5 },
    ],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Pending', hsePolicy: 'Current', esgPolicy: 'Current', annualValuationNotes: 'Under review.', consistencyCheck: false, consistencyCommentary: 'Minor discrepancy in counterparty risk rating — to be resolved at next oversight meeting.' },
    irrTarget: 9.5,
    esgScore: 82,
    dpi: 0.38,
    exitProjectedYear: 2036,
    spvId: 'spv-meridian',
  },
  {
    id: 'AST-003',
    name: 'Tyne Bridge Toll Road',
    stage: 'Operational',
    sector: 'Transport',
    subSector: 'Road Infrastructure',
    country: 'United Kingdom',
    fund: 'SeedDrive Infrastructure Fund II',
    fundExposure: 55.0,
    debtStack: true,
    shareholdingPct: 35,
    description: 'A 22 km toll road concession in the North East of England. 30-year concession expiring 2048.',
    acquisitionDate: '2018-11-01',
    keyExpiryDates: [{ label: 'Concession', date: '2048-10-31' }, { label: 'Senior Debt Maturity', date: '2038-06-30' }],
    keyOperationalDates: [{ label: 'Concession Start', date: '2018-11-01' }, { label: 'Last Traffic Survey', date: '2025-04-01' }],
    totalInvestmentValue: 110.0,
    lastReviewDate: '2025-03-31',
    reviewStatus: 'Reviewed',
    watchlistStatus: 'Watchlist',
    riskScore: 4,
    counterpartyRiskScore: 3,
    disputesStatus: 'Active',
    stakeholderStatus: 'Under pressure',
    situationUpdate: 'Traffic volumes 8% below forecast. Dispute with local authority over toll escalation clause. Legal counsel engaged.',
    irr: 7.2,
    yield1to10: 4.5,
    yield11to20: 5.8,
    yield21to25: 6.2,
    yieldLifetime: 5.4,
    multiple: 1.6,
    cashYieldActual: 3.8,
    cashYieldBudget: 4.8,
    irrHistory: [
      { period: 'Q1 2022', irr: 8.5 }, { period: 'Q2 2022', irr: 8.2 }, { period: 'Q3 2022', irr: 7.9 },
      { period: 'Q4 2022', irr: 7.6 }, { period: 'Q1 2023', irr: 7.5 }, { period: 'Q2 2023', irr: 7.4 },
      { period: 'Q3 2023', irr: 7.3 }, { period: 'Q4 2023', irr: 7.2 }, { period: 'Q1 2024', irr: 7.2 },
      { period: 'Q2 2024', irr: 7.1 }, { period: 'Q3 2024', irr: 7.2 }, { period: 'Q4 2024', irr: 7.2 },
    ],
    outperformanceDrivers: 'Toll escalation above RPI in 2021–2022.',
    underperformanceDrivers: 'Post-pandemic traffic recovery slower than modelled. Dispute with local authority creating uncertainty.',
    assetTimeline: 'Acquired November 2018. Traffic below forecast from 2023. Dispute commenced Q1 2025.',
    reviewSummary: 'Moved to watchlist. Legal dispute to be monitored monthly. Traffic recovery plan to be agreed with operator.',
    agreedActions: 'Monthly traffic monitoring report. Legal update by Q1 2026. Engage with local authority to resolve dispute.',
    nextReviewDate: '2026-03-31',
    valuationStatus: 'Under review',
    valuationNotes: 'Valuation held pending dispute resolution.',
    operationalFacts: 'Traffic volumes 8% below P50. No HSE incidents. Maintenance on schedule.',
    valuationAssumptions: 'Traffic recovery assumption under review. Dispute outcome material to valuation.',
    riskTrend: [3, 4, 4],
    monitoringCadence: 'monthly',
    counterparties: [
      { type: 'Client', name: 'Highways England', contact: 'concessions@highwaysengland.gov.uk', phone: '+44 300 123 5000', lastContacted: '2025-11-15', notes: 'Dispute correspondence ongoing.' },
      { type: 'Subcontractor', name: 'Amey PLC', contact: 'infra@amey.co.uk', phone: '+44 121 678 2000', lastContacted: '2025-10-01', notes: 'Maintenance contract performing.' },
      { type: 'Advisors (Dispute)', name: 'Linklaters LLP', contact: 'infra@linklaters.com', phone: '+44 20 7456 2000', lastContacted: '2025-12-01', notes: 'Legal strategy agreed.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Tom Hargreaves', email: 't.hargreaves@seedrive.com', phone: '+44 7700 900020', lastContacted: '2025-12-01', notes: '' },
      { role: 'Sector Lead', name: 'Fiona Walsh', email: 'f.walsh@seedrive.com', phone: '+44 7700 900021', lastContacted: '2025-11-25', notes: '' },
    ],
    valuationCreationActions: [
      { id: 'VC-003-A', action: 'Resolve toll escalation dispute', status: 'In progress', notes: 'Legal proceedings commenced.', owner: 'T. Hargreaves', targetDate: '2026-06-30', valueImpact: 18.0 },
    ],
    valuationPostActions: [
      { id: 'VC-003-B', action: 'Traffic demand stimulation programme', status: 'Planned', notes: 'Feasibility study to be commissioned.', owner: 'F. Walsh', targetDate: '2026-09-30', valueImpact: 7.5 },
    ],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Pending', hsePolicy: 'Current', esgPolicy: 'Pending update', annualValuationNotes: 'Held pending dispute resolution.', consistencyCheck: false, consistencyCommentary: 'Dispute risk not fully reflected in risk register — update required.' },
    irrTarget: 8.0,
    esgScore: 61,
    dpi: 0.71,
    exitProjectedYear: 2038,
    spvId: 'spv-tyne',
  },
  {
    id: 'AST-004',
    name: 'Avon Water Treatment Works',
    stage: 'Operational',
    sector: 'Utilities',
    subSector: 'Water',
    country: 'United Kingdom',
    fund: 'SeedDrive Infrastructure Fund II',
    fundExposure: 28.5,
    debtStack: false,
    shareholdingPct: 100,
    description: 'A water treatment facility serving 180,000 households in the South West of England. Long-term regulated revenue.',
    acquisitionDate: '2021-02-28',
    keyExpiryDates: [{ label: 'Regulatory Period', date: '2030-03-31' }, { label: 'Operating Licence', date: '2051-02-28' }],
    keyOperationalDates: [{ label: 'Acquisition', date: '2021-02-28' }, { label: 'AMP8 Start', date: '2025-04-01' }],
    totalInvestmentValue: 57.0,
    lastReviewDate: '2025-12-01',
    reviewStatus: 'Draft',
    watchlistStatus: 'Confirmed',
    riskScore: 2,
    counterpartyRiskScore: 1,
    disputesStatus: 'None',
    stakeholderStatus: 'Strong',
    situationUpdate: 'AMP8 regulatory period commenced. Capital programme on track. Ofwat engagement positive.',
    irr: 8.9,
    yield1to10: 5.5,
    yield11to20: 6.0,
    yield21to25: 5.8,
    yieldLifetime: 5.8,
    multiple: 1.9,
    cashYieldActual: 5.3,
    cashYieldBudget: 5.5,
    irrHistory: [
      { period: 'Q1 2022', irr: 8.5 }, { period: 'Q2 2022', irr: 8.6 }, { period: 'Q3 2022', irr: 8.7 },
      { period: 'Q4 2022', irr: 8.8 }, { period: 'Q1 2023', irr: 8.8 }, { period: 'Q2 2023', irr: 8.9 },
      { period: 'Q3 2023', irr: 8.9 }, { period: 'Q4 2023', irr: 8.9 }, { period: 'Q1 2024', irr: 8.9 },
      { period: 'Q2 2024', irr: 8.9 }, { period: 'Q3 2024', irr: 8.9 }, { period: 'Q4 2024', irr: 8.9 },
    ],
    outperformanceDrivers: 'Regulatory outperformance in AMP7. Efficient capital delivery.',
    underperformanceDrivers: 'Minor cost overruns on capital programme in 2023.',
    assetTimeline: 'Acquired February 2021. AMP7 outperformance achieved. AMP8 commenced April 2025.',
    reviewSummary: 'Review in draft. Confirmed performing. AMP8 capital programme to be monitored.',
    agreedActions: 'Quarterly capital programme update. AMP8 regulatory submission review by Q2 2026.',
    nextReviewDate: '2026-12-01',
    valuationStatus: 'Not required',
    valuationNotes: 'Regulatory asset base valuation not required until AMP8 mid-point review.',
    operationalFacts: 'Regulatory compliance maintained. No enforcement actions. Capital programme 94% on schedule.',
    valuationAssumptions: 'RAB growth assumption 3.2% p.a. WACC as per Ofwat determination.',
    riskTrend: [2, 2, 2],
    monitoringCadence: 'annual',
    counterparties: [
      { type: 'Regulator', name: 'Ofwat', contact: 'enquiries@ofwat.gov.uk', phone: '+44 121 644 7500', lastContacted: '2025-10-01', notes: 'AMP8 engagement positive.' },
      { type: 'Subcontractor', name: 'Mott MacDonald', contact: 'water@mottmac.com', phone: '+44 1276 858585', lastContacted: '2025-11-01', notes: 'Capital programme delivery.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Rachel Patel', email: 'r.patel@seedrive.com', phone: '+44 7700 900030', lastContacted: '2025-12-01', notes: '' },
      { role: 'Sector Lead', name: 'James Donovan', email: 'j.donovan@seedrive.com', phone: '+44 7700 900000', lastContacted: '2025-11-30', notes: '' },
    ],
    valuationCreationActions: [
      { id: 'VC-004-A', action: 'Maximise AMP8 regulatory outperformance', status: 'In progress', notes: 'Capital programme tracking ahead of schedule.', owner: 'R. Patel', targetDate: '2030-03-31', valueImpact: 22.0 },
    ],
    valuationPostActions: [],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Complete', hsePolicy: 'Current', esgPolicy: 'Current', annualValuationNotes: 'Not required this cycle.', consistencyCheck: true, consistencyCommentary: 'All information consistent with risk register.' },
    irrTarget: 8.5,
    esgScore: 74,
    dpi: 0.44,
    exitProjectedYear: 2033,
    spvId: 'spv-avon',
  },
  {
    id: 'AST-005',
    name: 'Porto Digital Hub',
    stage: 'In Construction',
    sector: 'Digital Infrastructure',
    subSector: 'Data Centre',
    country: 'Portugal',
    fund: 'SeedDrive Infrastructure Fund II',
    fundExposure: 38.0,
    debtStack: true,
    shareholdingPct: 70,
    description: 'A 40 MW hyperscale data centre under construction in Porto, Portugal. Anchor tenant agreement signed with a major cloud provider.',
    acquisitionDate: '2023-05-10',
    keyExpiryDates: [{ label: 'Anchor Tenant Agreement', date: '2038-05-09' }, { label: 'Construction Loan', date: '2026-12-31' }],
    keyOperationalDates: [{ label: 'Construction Start', date: '2023-09-01' }, { label: 'Expected COD', date: '2026-06-30' }],
    totalInvestmentValue: 76.0,
    lastReviewDate: '2025-11-15',
    reviewStatus: 'Submitted',
    watchlistStatus: 'Confirmed',
    riskScore: 3,
    counterpartyRiskScore: 2,
    disputesStatus: 'None',
    stakeholderStatus: 'Strong',
    situationUpdate: 'Construction 68% complete. On schedule for Q2 2026 COD. Anchor tenant confirmed. Minor supply chain delays managed.',
    irr: 14.2,
    yield1to10: 8.5,
    yield11to20: 9.2,
    yield21to25: 8.8,
    yieldLifetime: 8.9,
    multiple: 2.4,
    cashYieldActual: 0,
    cashYieldBudget: 0,
    irrHistory: [
      { period: 'Q1 2024', irr: 13.8 }, { period: 'Q2 2024', irr: 14.0 }, { period: 'Q3 2024', irr: 14.1 },
      { period: 'Q4 2024', irr: 14.2 }, { period: 'Q1 2025', irr: 14.2 }, { period: 'Q2 2025', irr: 14.2 },
    ],
    outperformanceDrivers: 'Anchor tenant agreement secured above underwrite. Construction costs tracking below budget.',
    underperformanceDrivers: 'Minor supply chain delays in Q3 2024. Power connection timeline risk.',
    assetTimeline: 'Acquired May 2023. Construction commenced September 2023. 68% complete as at Q4 2025.',
    reviewSummary: 'Review submitted. Construction progress confirmed. Power connection to be monitored.',
    agreedActions: 'Monthly construction progress report. Power connection milestone review by Q1 2026.',
    nextReviewDate: '2026-05-31',
    valuationStatus: 'Not required',
    valuationNotes: 'Valuation not required until COD.',
    operationalFacts: 'Construction 68% complete. No HSE incidents. Anchor tenant confirmed.',
    valuationAssumptions: 'COD assumed Q2 2026. Anchor tenant revenue from Q3 2026.',
    riskTrend: [3, 3, 3],
    monitoringCadence: 'quarterly',
    counterparties: [
      { type: 'Subcontractor', name: 'Mace Group', contact: 'infra@macegroup.com', phone: '+44 20 3522 3000', lastContacted: '2025-12-01', notes: 'Construction on schedule.' },
      { type: 'Client', name: 'Hyperscale Cloud Co.', contact: 'infra@hyperscale.example', phone: '+1 650 000 0000', lastContacted: '2025-11-01', notes: 'Anchor tenant agreement confirmed.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Ana Ferreira', email: 'a.ferreira@seedrive.com', phone: '+44 7700 900040', lastContacted: '2025-12-01', notes: '' },
      { role: 'Sector Lead', name: 'David Okafor', email: 'd.okafor@seedrive.com', phone: '+44 7700 900002', lastContacted: '2025-11-28', notes: '' },
    ],
    valuationCreationActions: [
      { id: 'VC-005-A', action: 'Secure second anchor tenant', status: 'Market', notes: 'Market engagement commenced.', owner: 'A. Ferreira', targetDate: '2026-09-30', valueImpact: 15.0 },
    ],
    valuationPostActions: [],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Pending', hsePolicy: 'Current', esgPolicy: 'Current', annualValuationNotes: 'Not required until COD.', consistencyCheck: true, consistencyCommentary: 'Construction risk reflected in risk register. Consistent.' },
    irrTarget: 15.0,
    esgScore: 68,
    dpi: 0.12,
    exitProjectedYear: 2031,
    spvId: 'spv-porto',
  },
  {
    id: 'AST-006',
    name: 'Elbe Biomass Plant',
    stage: 'Operational',
    sector: 'Renewable Energy',
    subSector: 'Biomass',
    country: 'Germany',
    fund: 'SeedDrive Infrastructure Fund I',
    fundExposure: 22.0,
    debtStack: true,
    shareholdingPct: 50,
    description: 'A 30 MW biomass combined heat and power plant in Saxony, Germany. EEG subsidy in place through 2032.',
    acquisitionDate: '2017-06-30',
    keyExpiryDates: [{ label: 'EEG Subsidy', date: '2032-06-29' }, { label: 'Fuel Supply Agreement', date: '2027-12-31' }],
    keyOperationalDates: [{ label: 'Acquisition', date: '2017-06-30' }, { label: 'Fuel Contract Renewal', date: '2022-01-01' }],
    totalInvestmentValue: 44.0,
    lastReviewDate: '2025-09-15',
    reviewStatus: 'Reviewed',
    watchlistStatus: 'Escalated',
    riskScore: 5,
    counterpartyRiskScore: 4,
    disputesStatus: 'Active',
    stakeholderStatus: 'Strained',
    situationUpdate: 'Fuel supply counterparty in financial difficulty. Dispute over fuel pricing. Escalated to Investment Committee. Legal proceedings commenced.',
    irr: 6.1,
    yield1to10: 4.2,
    yield11to20: 5.0,
    yield21to25: 4.5,
    yieldLifetime: 4.6,
    multiple: 1.4,
    cashYieldActual: 3.2,
    cashYieldBudget: 5.0,
    irrHistory: [
      { period: 'Q1 2022', irr: 8.0 }, { period: 'Q2 2022', irr: 7.5 }, { period: 'Q3 2022', irr: 7.0 },
      { period: 'Q4 2022', irr: 6.8 }, { period: 'Q1 2023', irr: 6.5 }, { period: 'Q2 2023', irr: 6.3 },
      { period: 'Q3 2023', irr: 6.2 }, { period: 'Q4 2023', irr: 6.1 }, { period: 'Q1 2024', irr: 6.1 },
      { period: 'Q2 2024', irr: 6.1 }, { period: 'Q3 2024', irr: 6.1 }, { period: 'Q4 2024', irr: 6.1 },
    ],
    outperformanceDrivers: 'EEG subsidy provides revenue floor.',
    underperformanceDrivers: 'Fuel cost escalation. Counterparty financial distress. Dispute over pricing.',
    assetTimeline: 'Acquired June 2017. Fuel contract renewed 2022. Counterparty distress emerged Q3 2024. Escalated Q1 2025.',
    reviewSummary: 'Escalated to Investment Committee. Legal proceedings commenced. Fuel supply alternative being sourced.',
    agreedActions: 'Source alternative fuel supplier by Q2 2026. Legal update monthly. IC briefing quarterly.',
    nextReviewDate: '2026-03-15',
    valuationStatus: 'Under review',
    valuationNotes: 'Valuation under review pending fuel supply resolution.',
    operationalFacts: 'Plant operational but at reduced capacity. Fuel supply constrained.',
    valuationAssumptions: 'Fuel cost assumption under review. Dispute outcome material.',
    riskTrend: [3, 4, 5],
    monitoringCadence: 'monthly',
    delegatedAuthorityReason: 'Counterparty financial distress and active legal dispute exceed standard asset management authority. Escalated to Investment Committee per reserved matters policy.',
    counterparties: [
      { type: 'Subcontractor', name: 'BioEnergy GmbH', contact: 'fuel@bioenergy.de', phone: '+49 341 000 0000', lastContacted: '2025-11-20', notes: 'Financial distress. Dispute ongoing.' },
      { type: 'Regulator', name: 'Bundesnetzagentur', contact: 'info@bundesnetzagentur.de', phone: '+49 228 14 0', lastContacted: '2025-08-01', notes: 'EEG compliance confirmed.' },
      { type: 'Advisors (Dispute)', name: 'Freshfields Bruckhaus', contact: 'energy@freshfields.com', phone: '+49 69 27308 0', lastContacted: '2025-12-01', notes: 'Legal proceedings commenced.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Klaus Weber', email: 'k.weber@seedrive.com', phone: '+44 7700 900050', lastContacted: '2025-12-01', notes: '' },
      { role: 'Sector Lead', name: 'David Okafor', email: 'd.okafor@seedrive.com', phone: '+44 7700 900002', lastContacted: '2025-11-28', notes: '' },
      { role: 'Advisors (Dispute)', name: 'Freshfields Bruckhaus', email: 'energy@freshfields.com', phone: '+49 69 27308 0', lastContacted: '2025-12-01', notes: 'Legal proceedings.' },
    ],
    valuationCreationActions: [
      { id: 'VC-006-A', action: 'Secure alternative fuel supply', status: 'In progress', notes: 'Three alternative suppliers being evaluated.', owner: 'K. Weber', targetDate: '2026-06-30', valueImpact: 20.0 },
    ],
    valuationPostActions: [
      { id: 'VC-006-B', action: 'Resolve fuel pricing dispute', status: 'In progress', notes: 'Legal proceedings commenced.', owner: 'K. Weber', targetDate: '2026-09-30', valueImpact: 15.0 },
    ],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Pending', hsePolicy: 'Current', esgPolicy: 'Pending update', annualValuationNotes: 'Under review.', consistencyCheck: false, consistencyCommentary: 'Escalation risk not fully reflected in risk register. Update required urgently.' },
    irrTarget: 11.0,
    esgScore: 71,
    dpi: 0.00,
    exitProjectedYear: 2037,
    spvId: 'spv-elbe',
  },
  {
    id: 'AST-007',
    name: 'Lisbon Metro Extension',
    stage: 'In Construction',
    sector: 'Transport',
    subSector: 'Urban Rail',
    country: 'Portugal',
    fund: 'SeedDrive Infrastructure Fund II',
    fundExposure: 48.0,
    debtStack: true,
    shareholdingPct: 25,
    description: 'A 6.2 km metro extension in Lisbon, Portugal. Government availability payment concession. 35-year concession.',
    acquisitionDate: '2022-09-01',
    keyExpiryDates: [{ label: 'Concession', date: '2057-08-31' }, { label: 'Construction Completion', date: '2027-03-31' }],
    keyOperationalDates: [{ label: 'Construction Start', date: '2023-01-01' }, { label: 'Expected Revenue Start', date: '2027-06-01' }],
    totalInvestmentValue: 96.0,
    lastReviewDate: '2025-10-01',
    reviewStatus: 'Reviewed',
    watchlistStatus: 'Watchlist',
    riskScore: 4,
    counterpartyRiskScore: 3,
    disputesStatus: 'Minor',
    stakeholderStatus: 'Satisfactory',
    situationUpdate: 'Construction 45% complete. Geotechnical delays identified. Programme risk flagged. Monitoring monthly.',
    irr: 11.5,
    yield1to10: 0,
    yield11to20: 7.8,
    yield21to25: 8.2,
    yieldLifetime: 7.2,
    multiple: 2.2,
    cashYieldActual: 0,
    cashYieldBudget: 0,
    irrHistory: [
      { period: 'Q1 2024', irr: 12.0 }, { period: 'Q2 2024', irr: 11.8 }, { period: 'Q3 2024', irr: 11.6 },
      { period: 'Q4 2024', irr: 11.5 }, { period: 'Q1 2025', irr: 11.5 }, { period: 'Q2 2025', irr: 11.5 },
    ],
    outperformanceDrivers: 'Government availability payment provides revenue certainty.',
    underperformanceDrivers: 'Geotechnical delays. Programme risk increasing.',
    assetTimeline: 'Acquired September 2022. Construction commenced January 2023. Geotechnical delays identified Q3 2024.',
    reviewSummary: 'Moved to watchlist due to programme risk. Monthly monitoring in place.',
    agreedActions: 'Monthly construction progress report. Geotechnical risk mitigation plan by Q1 2026.',
    nextReviewDate: '2026-04-01',
    valuationStatus: 'Not required',
    valuationNotes: 'Valuation not required until revenue commencement.',
    operationalFacts: 'Construction 45% complete. Geotechnical delays. No HSE incidents.',
    valuationAssumptions: 'Revenue start assumed Q2 2027. Delay risk factored into base case.',
    riskTrend: [3, 3, 4],
    monitoringCadence: 'monthly',
    counterparties: [
      { type: 'Client', name: 'Metropolitano de Lisboa', contact: 'concessions@metrolisboa.pt', phone: '+351 21 350 0100', lastContacted: '2025-11-01', notes: 'Programme review meeting scheduled.' },
      { type: 'Subcontractor', name: 'Ferrovial Construction', contact: 'infra@ferrovial.com', phone: '+34 91 586 2500', lastContacted: '2025-12-01', notes: 'Geotechnical mitigation plan submitted.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Ana Ferreira', email: 'a.ferreira@seedrive.com', phone: '+44 7700 900040', lastContacted: '2025-12-01', notes: '' },
      { role: 'Sector Lead', name: 'Fiona Walsh', email: 'f.walsh@seedrive.com', phone: '+44 7700 900021', lastContacted: '2025-11-25', notes: '' },
    ],
    valuationCreationActions: [
      { id: 'VC-007-A', action: 'Mitigate geotechnical delay risk', status: 'In progress', notes: 'Mitigation plan submitted by contractor.', owner: 'A. Ferreira', targetDate: '2026-06-30', valueImpact: 10.0 },
    ],
    valuationPostActions: [],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Pending', hsePolicy: 'Current', esgPolicy: 'Current', annualValuationNotes: 'Not required until revenue commencement.', consistencyCheck: true, consistencyCommentary: 'Programme risk reflected in risk register. Consistent.' },
    irrTarget: 10.0,
    esgScore: 78,
    dpi: 0.00,
    exitProjectedYear: 2040,
    spvId: 'spv-lisbon',
  },
  {
    id: 'AST-008',
    name: 'Nordic Fibre Network',
    stage: 'Operational',
    sector: 'Digital Infrastructure',
    subSector: 'Fibre',
    country: 'Sweden',
    fund: 'SeedDrive Infrastructure Fund II',
    fundExposure: 33.5,
    debtStack: false,
    shareholdingPct: 80,
    description: 'A 2,400 km fibre optic network in rural Sweden. Long-term IRU agreements with major telecoms operators.',
    acquisitionDate: '2022-03-15',
    keyExpiryDates: [{ label: 'IRU Agreement (Telia)', date: '2042-03-14' }, { label: 'IRU Agreement (Ericsson)', date: '2040-03-14' }],
    keyOperationalDates: [{ label: 'Acquisition', date: '2022-03-15' }, { label: 'Network Upgrade', date: '2024-06-30' }],
    totalInvestmentValue: 67.0,
    lastReviewDate: '2025-11-01',
    reviewStatus: 'Reviewed',
    watchlistStatus: 'Exit case',
    riskScore: 2,
    counterpartyRiskScore: 1,
    disputesStatus: 'None',
    stakeholderStatus: 'Strong',
    situationUpdate: 'Asset performing strongly. Exit process commenced. Strategic buyer identified. IC approval for exit process obtained.',
    irr: 16.8,
    yield1to10: 9.2,
    yield11to20: 10.1,
    yield21to25: 9.5,
    yieldLifetime: 9.6,
    multiple: 2.8,
    cashYieldActual: 9.0,
    cashYieldBudget: 8.5,
    irrHistory: [
      { period: 'Q1 2023', irr: 14.5 }, { period: 'Q2 2023', irr: 15.0 }, { period: 'Q3 2023', irr: 15.5 },
      { period: 'Q4 2023', irr: 16.0 }, { period: 'Q1 2024', irr: 16.3 }, { period: 'Q2 2024', irr: 16.5 },
      { period: 'Q3 2024', irr: 16.7 }, { period: 'Q4 2024', irr: 16.8 }, { period: 'Q1 2025', irr: 16.8 },
    ],
    outperformanceDrivers: 'Strong demand for rural fibre. IRU pricing above underwrite. Network upgrade completed ahead of schedule.',
    underperformanceDrivers: 'None material.',
    assetTimeline: 'Acquired March 2022. Network upgrade completed June 2024. Exit process commenced Q4 2025.',
    reviewSummary: 'Exit case confirmed. Strategic buyer identified. Process to be managed by M&A team.',
    agreedActions: 'Appoint sell-side adviser by Q1 2026. Data room preparation by Q2 2026. Target completion Q4 2026.',
    nextReviewDate: '2026-06-01',
    valuationStatus: 'Submitted',
    valuationNotes: 'Exit valuation submitted. Indicative bid received above carrying value.',
    operationalFacts: 'Network availability 99.8%. All IRU agreements current. No HSE incidents.',
    valuationAssumptions: 'Exit multiple based on comparable transactions. Indicative bid above carrying value.',
    riskTrend: [2, 2, 2],
    monitoringCadence: 'quarterly',
    counterparties: [
      { type: 'Client', name: 'Telia Company', contact: 'infra@telia.com', phone: '+46 8 504 550 00', lastContacted: '2025-11-01', notes: 'IRU agreement current.' },
      { type: 'Client', name: 'Ericsson AB', contact: 'infra@ericsson.com', phone: '+46 10 719 0000', lastContacted: '2025-10-15', notes: 'IRU agreement current.' },
    ],
    internalContacts: [
      { role: 'Asset Lead', name: 'Erik Lindqvist', email: 'e.lindqvist@seedrive.com', phone: '+44 7700 900060', lastContacted: '2025-12-01', notes: '' },
      { role: 'Sector Lead', name: 'David Okafor', email: 'd.okafor@seedrive.com', phone: '+44 7700 900002', lastContacted: '2025-11-28', notes: '' },
    ],
    valuationCreationActions: [
      { id: 'VC-008-A', action: 'Maximise exit valuation', status: 'In progress', notes: 'Sell-side adviser to be appointed.', owner: 'E. Lindqvist', targetDate: '2026-12-31', valueImpact: 35.0 },
    ],
    valuationPostActions: [],
    governanceDocs: { boardPapers: 'Linked', financialModel: 'Linked', financeReview: 'Complete', hsePolicy: 'Current', esgPolicy: 'Current', annualValuationNotes: 'Exit valuation submitted.', consistencyCheck: true, consistencyCommentary: 'All information consistent with risk register.' },
    irrTarget: 14.0,
    esgScore: 65,
    dpi: 0.89,
    exitProjectedYear: 2029,
    spvId: 'spv-nordic',
  },
];

export const AUDIT_LOG = [
  { id: 'AL-001', timestamp: '2025-12-01 09:15', user: 'S. Mitchell', action: 'Review created', asset: 'Solano Wind Farm', detail: 'Annual review pack created for Q4 2025.' },
  { id: 'AL-002', timestamp: '2025-11-28 14:30', user: 'E. Lindqvist', action: 'Oversight decision recorded', asset: 'Nordic Fibre Network', detail: 'Exit case confirmed by Investment Committee.' },
  { id: 'AL-003', timestamp: '2025-11-25 11:00', user: 'K. Weber', action: 'Escalated', asset: 'Elbe Biomass Plant', detail: 'Escalated to IC due to counterparty financial distress.' },
  { id: 'AL-004', timestamp: '2025-11-20 16:45', user: 'T. Hargreaves', action: 'Moved to watchlist', asset: 'Tyne Bridge Toll Road', detail: 'Moved to watchlist following traffic underperformance and legal dispute.' },
  { id: 'AL-005', timestamp: '2025-11-15 10:00', user: 'A. Ferreira', action: 'Review created', asset: 'Porto Digital Hub', detail: 'Periodic review pack created for Q3 2025.' },
  { id: 'AL-006', timestamp: '2025-11-10 09:30', user: 'C. Reyes', action: 'Actions issued', asset: 'Meridian Solar Park', detail: 'PPA renewal and revenue hedging actions issued following oversight decision.' },
  { id: 'AL-007', timestamp: '2025-10-30 15:00', user: 'R. Patel', action: 'Submitted deadline met', asset: 'Avon Water Treatment Works', detail: 'Review pack submitted on time for Q3 2025 oversight meeting.' },
  { id: 'AL-008', timestamp: '2025-10-15 11:30', user: 'A. Ferreira', action: 'Oversight decision recorded', asset: 'Lisbon Metro Extension', detail: 'Moved to watchlist due to geotechnical programme risk.' },
  { id: 'AL-009', timestamp: '2025-09-30 14:00', user: 'S. Mitchell', action: 'Review created', asset: 'Solano Wind Farm', detail: 'Q3 2025 periodic review pack created.' },
  { id: 'AL-010', timestamp: '2025-09-15 09:00', user: 'K. Weber', action: 'Review created', asset: 'Elbe Biomass Plant', detail: 'Distress signal review pack created following fuel supply issues.' },
  { id: 'AL-011', timestamp: '2025-08-01 10:00', user: 'E. Lindqvist', action: 'Actions closed', asset: 'Nordic Fibre Network', detail: 'Network upgrade action closed following completion ahead of schedule.' },
  { id: 'AL-012', timestamp: '2025-07-15 14:30', user: 'C. Reyes', action: 'Review created', asset: 'Meridian Solar Park', detail: 'Performance variance review triggered by H1 2025 underperformance.' },
];

export const OVERSIGHT_QUEUE = [
  { id: 'OQ-001', asset: 'Solano Wind Farm', triggerReason: 'Periodic review', reviewDate: '2026-01-15', owner: 'S. Mitchell', status: 'Submitted', packId: 'AST-001' },
  { id: 'OQ-002', asset: 'Meridian Solar Park', triggerReason: 'Performance variance', reviewDate: '2026-01-15', owner: 'C. Reyes', status: 'Submitted', packId: 'AST-002' },
  { id: 'OQ-003', asset: 'Elbe Biomass Plant', triggerReason: 'Distress signal', reviewDate: '2026-01-15', owner: 'K. Weber', status: 'Submitted', packId: 'AST-006' },
  { id: 'OQ-004', asset: 'Avon Water Treatment Works', triggerReason: 'Periodic review', reviewDate: '2026-02-05', owner: 'R. Patel', status: 'Draft', packId: 'AST-004' },
  { id: 'OQ-005', asset: 'Porto Digital Hub', triggerReason: 'Reserved matter', reviewDate: '2026-02-05', owner: 'A. Ferreira', status: 'Submitted', packId: 'AST-005' },
];

export const UPCOMING_REVIEWS = [
  { asset: 'Avon Water Treatment Works', triggerReason: 'Periodic review', reviewDate: '2026-01-15', owner: 'R. Patel', status: 'Draft' },
  { asset: 'Meridian Solar Park', triggerReason: 'Performance variance', reviewDate: '2026-01-20', owner: 'C. Reyes', status: 'Submitted' },
  { asset: 'Elbe Biomass Plant', triggerReason: 'Distress signal', reviewDate: '2026-02-01', owner: 'K. Weber', status: 'Submitted' },
  { asset: 'Tyne Bridge Toll Road', triggerReason: 'Counterparty issue', reviewDate: '2026-02-15', owner: 'T. Hargreaves', status: 'Draft' },
  { asset: 'Lisbon Metro Extension', triggerReason: 'Performance variance', reviewDate: '2026-03-01', owner: 'A. Ferreira', status: 'Draft' },
  { asset: 'Porto Digital Hub', triggerReason: 'Reserved matter', reviewDate: '2026-03-15', owner: 'A. Ferreira', status: 'Draft' },
];
